import { Group as AdminGroup } from 'api/groupAdmin';
import { ListingMini } from 'api/types/groups-mini.types';
import {
  AddressWithDescription,
  FilestackImageData,
} from 'api/types/shared.types';
import { getJson, postJson } from 'utils/http';

export type Creator = {
  id: string;
  firstName: string;
  lastName: string;
  description: string | null | undefined;
  links: Array<string>;
  imageSrc: string | null | undefined;
};
export type Group = {
  id: string;
  name: string;
  description: string;
  descriptionTruncated: string;
  image: FilestackImageData | null | undefined;
  locale: string;
  links: Array<string>;
  email: string | null | undefined;
  phone: string | null | undefined;
  address: AddressWithDescription;
  url: Record<string, string>;
  created: string;
  updated: string;
  org:
    | {
        id: string;
        name: string;
        orgType: string;
        url: Record<string, string>;
        address: {
          city: string;
          stateCode: string;
          country: string;
        };
      }
    | null
    | undefined;
  volop: Array<ListingMini>;
  areasOfFocus: Array<string>;
};
export function createGroup(
  groupInfo: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<AdminGroup> {
  return postJson('/data/website/groups', groupInfo).then(({ group }) => group);
}
export function fetchGroup(groupId: string): Promise<Group> {
  return getJson(`/data/website/groups/${groupId}`).then(
    ({ data, group }) => data || group
  );
}
export function requestAdmin(groupId: string, requestTo: string) {
  return postJson(`/data/website/groups/${groupId}/request-admin`, {
    requestTo,
  });
}
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function validateGroup(payload: Record<string, any>): Promise<{
  group: Group;
}> {
  return postJson('/data/website/groups-validation', payload);
}
